import React from 'react';
import { useTranslation } from 'react-i18next';

const Hero = ({ content }) => {
  const { t } = useTranslation();
  
  return (
    <section 
      className="relative flex items-center min-h-[90vh] overflow-hidden"
      style={{
        backgroundImage: `url(${content.image})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Dark overlay */}
      <div className="absolute inset-0 bg-black/50"></div>
      
      <div className="relative z-10 max-w-8xl mx-auto px-4 sm:px-6 lg:px-8 py-32">
        <div className="max-w-2xl ml-0">
          <h1 className="text-5xl font-bold text-white mb-6 text-left">{t('hero.title')}</h1>
          <p className="text-xl text-white/90 mb-8 text-left">{t('hero.description')}</p>
          <a 
            href="#contact" 
            className="rounded-button bg-custom text-white px-8 py-3 text-lg font-medium hover:bg-custom/90 inline-block"
          >
            {t('hero.button')}
          </a>
        </div>
      </div>
    </section>
  );
};

export default Hero;
